<script lang="ts">
  import type { AccordionPanel } from '$lib/types/contentTypes';
  import { BUTTON_VARIANT, BUTTON_SIZE, ACCORDION_VARIANT } from '$lib/constants/constants';
  import { serializeSchema } from '$lib/helpers/serializeSchema';
  import { richTextFormatter } from '$lib/helpers/richTextHelper';
  import Accordion from './Accordion.svelte';
  import AccordionItem from './AccordionItem.svelte';
  import Button from '../../control/Button.svelte';

  export let accordionPanel: AccordionPanel;
  export let customClass: string = '';

  let mainEntity: Array<Object> = [];

  $: accordionPanel?.itemsCollection?.items?.forEach((question) => {
    mainEntity.push({
      '@type': 'Question',
      name: question.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: richTextFormatter(question.content),
      },
    });
  });

  let structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  };
</script>

<svelte:head>
  {#if accordionPanel?.variant === ACCORDION_VARIANT.FAQ || accordionPanel?.variant === ACCORDION_VARIANT.FAQ_CTA}
    {@html serializeSchema(structuredData)}
  {/if}
</svelte:head>

<section class="flex flex-col gap-12 items-center lg:gap-16 {customClass}">
  <div class="flex flex-col gap-4 text-center w-full max-w-768">
    {#if accordionPanel?.eyebrowText}
      <p class="text-primary-500 text-sm lg:text-md font-semibold">{accordionPanel?.eyebrowText}</p>
    {/if}
    {#if accordionPanel?.heading}
      <h2 class="text-gray-900 text-30 lg:text-display-md font-semibold">
        {accordionPanel?.heading}
      </h2>
    {/if}
    {#if accordionPanel?.shortDescription}
      <p class="text-gray-400 text-lg lg:text-xl font-medium">{accordionPanel?.shortDescription}</p>
    {/if}
  </div>
  <div class="w-full max-w-832">
    <Accordion collapse>
      {#if accordionPanel?.itemsCollection?.items}
        {#each accordionPanel?.itemsCollection?.items as accordionItem}
          <AccordionItem
            open={false}
            customClass="px-4 py-6 flex flex-col gap-2 border-t border-gray-200"
          >
            <h3 slot="title" class="text-gray-900 text-lg font-semibold text-left">
              {accordionItem.title}
            </h3>
            <p slot="content">{@html richTextFormatter(accordionItem.content)}</p>
          </AccordionItem>
        {/each}
      {/if}
    </Accordion>
  </div>
  {#if accordionPanel?.variant === ACCORDION_VARIANT.FAQ_CTA}
    <div
      class="flex flex-col justify-center items-center gap-8 p-8 bg-gray-50 rounded-xxl w-full max-w-1008 lg:py-16 lg:my-16"
    >
      <div class="text-center flex flex-col gap-2 w-full max-w-768">
        <h3 class="text-xl text-gray-900 font-semibold">Still have questions?</h3>
        <p class="text-gray-600 lg:text-lg">
          Can't find the answer you're looking for? Visit our Sweat Support Center.
        </p>
      </div>
      <Button
        text="Visit our Sweat Support Center"
        variant={BUTTON_VARIANT.PRIMARY}
        buttonSize={BUTTON_SIZE.LARGE}
        customClass="py-3 gap-0 text-center"
        url="https://sweat.zendesk.com/hc/en-us/requests/ne"
        openInNewTab
      />
    </div>
  {/if}
</section>
